export default __webpack_public_path__ + "static/media/instoremusic2.fe7fd30d.jpg";